import 'react-day-picker/dist/style.css';
import { ReactNode } from 'react';
import { PopoverOrigin } from '@mui/material';

import { ValueSelectorBody } from '@/components';

type TValueSelectorProps = {
  handleClear: () => void;
  anchorEl?: HTMLElement;
  setAnchorEl: (anchorEl?: HTMLElement) => void;
  anchorOrigin: PopoverOrigin;
  children: ReactNode;
};

export const ValueSelector = ({
  handleClear,
  anchorEl,
  setAnchorEl,
  anchorOrigin,
  children,
}: TValueSelectorProps) => {
  const handleApplySelection = () => {
    setAnchorEl(undefined);
  };
  return (
    <ValueSelectorBody
      handleClear={handleClear}
      handleApplySelection={handleApplySelection}
      anchorEl={anchorEl}
      setAnchorEl={setAnchorEl}
      anchorOrigin={anchorOrigin}
    >
      {children}
    </ValueSelectorBody>
  );
};
